import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { UserService } from '../../../common/user.service';
import {MdSnackBar,MdSnackBarConfig,MdDialog, MdDialogRef} from '@angular/material';
import { Router, ActivatedRoute, Params} from '@angular/router';
import { EventService } from '../../../admin/event.service';
import { CountryService } from '../../../common/country.service';
import {FormBuilder, Validators} from "@angular/forms";
import { ExcursionService } from '../../../common/excursion.service';
import {TripService} from '../../trip.service';
import { TextMaskModule } from 'angular2-text-mask';
import {IMyDpOptions} from 'mydatepicker';




@Component({
  selector: 'app-trip-add-attendee',
  templateUrl: './trip-add-attendee.component.html',
  styleUrls: ['./trip-add-attendee.component.css', '../../../app.component.css', '../../admin.css'],
  providers: [TripService,ExcursionService,CountryService]

})
export class TripAddAttendeeComponent implements OnInit {
  eventId: any;
  userId: any;
  eventUserId :any;
  users:any;
  excursions=[];
  count:any;
  spinner: boolean = false;
  disables: boolean =false;
  public mask =[/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  todayDate = new Date();
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    disableSince: {year: this.todayDate.getFullYear(), month: this.todayDate.getMonth()+1, day: this.todayDate.getDate()+1}
  };



  constructor(private pageTitle: Title,private router: Router, public dialogRef: MdDialogRef<TripAddAttendeeComponent>, private formBuilder: FormBuilder, private tripService: TripService,private excursionService: ExcursionService,private snackBar: MdSnackBar,private countryService: CountryService) { }

  ngOnInit() {
    if(this.eventId && this.userId && this.eventUserId){
      this.excursionService.getExcursions(this.eventId).subscribe(response => {
        this.excursions = response;
        this.assignUserExcursions(this.users);
      });
    }else{
      this.snackBar.open('something went wrong!','',{duration:4000});
      this.dialogRef.close();
    }

    this.users=({
      userId : '',
      firstName : '',
      lastName : '',
      email : '',
      cellPhone : '',
      password : '',
      rePassword : '',
      eventUser : {
        eventId : this.eventId,
        userId : '',
        badgeName : '',
        firstName : '',
        lastName : '',
        cellPhone : '',
        companyName : '',
        addressLine1 : '',
        addressLine2 : '',
        countryId : '',
        stateId : '',
        city : '',
        zipcode : '',
        workPhone : '',
        extension : '',
        type : 'Trip',
        designation : 'Guest',
        arriveByPlane : 0,
        arriveFlightName : '',
        arriveFlightNumber : '',
        arriveDateTime : '',
        arriveDateTime_ : new Date(),
        arriveNames : '',
        returnFlightName : '',
        returnFlightNumber : '',
        returnDateTime : '',
        returnDateTime_ : new Date(),
        returnNames : '',
        attendAwardCelebration : 1,
        userExcursions : [],
        price : 0.00,
        mealRestriction : 0,
        mealChoice : 0,
        mealComments : '',
        parentEventUserId:this.eventUserId,
        parentUserId:this.userId,
        title : '',
        dob_ : '',
        dob:'',
        emergencyPhone : '',
        roomType:'',
        roomTypeComments:'',
        beddingPreference:''
      }
    });
    this.assignUserExcursions(this.users);
  }

  assignUserExcursions(user){
    user.eventUser.userExcursions = [];
    for(var i=0;i<this.excursions.length;i++)
      user.eventUser.userExcursions.push({
        userId : '',
        eventId : user.eventUser.eventId,
        excursionId : this.excursions[i].id,
        checked : false,
        questions : [],
        userQuestions : []
      });
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  validatePhone(phone){
    //var re1 = /^[0-9]{10}$/;
    //var re2 = /^(\()?\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/;
    //return (re1.test(phone) || re2.test(phone));
    //var re = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
    var re = /^[0-9]{10}$/;
    return re.test(phone.replace(/-/g, ""));
  }

  validateZip(zip,country){
    return true;
    // if(country=='Canada')
    //   var re = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
    // else
    //   var re = /^\d{5}(-\d{4})?$/;
    // return re.test(zip);
  }

  validateDigit(num,min,max){
    return num.match("^[0-9]{"+min+","+max+"}$");
  }


  dateTimeFormat(dt){
    if(dt)
    {
      var m = dt.getMonth()+1;
      if(m<10)
        m='0'+m;
      var d = dt.getDate();
      if(d<10)
        d='0'+d;
      return dt.getFullYear()+'-'+m+'-'+d+' 00:00:00';
    }
    else
      return '';
  }

  usDateTimeFormat(dt){
    if(dt)
    {
      if(typeof dt=='string')
      {
        dt = dt.split(' ');
        dt = dt[0].split('-');
        return dt[1]+'/'+dt[2]+'/'+dt[0];
      }
      else
      {
        var m = dt.getMonth()+1;
        if(m<10)
          m='0'+m;
        var d = dt.getDate();
        if(d<10)
          d='0'+d;
        return m+'/'+d+'/'+dt.getFullYear();
      }
    }
    else
      return '';
  }

  excursionSelected(userExcursion){
    this.spinner = true;
    userExcursion.userQuestions = [];
    userExcursion.questions = [];
    if(userExcursion.checked)
    {
      for(var i=0;i<this.excursions.length;i++)
        if(this.excursions[i].id==userExcursion.excursionId)
        {
          userExcursion.excursionName = this.excursions[i].name;
          break;
        }
      this.excursionService.getExcursionQuestionsWithOptions({excursionId:userExcursion.excursionId}).subscribe(
              response => {
            this.spinner = false;
            userExcursion.questions = response;
            userExcursion.userQuestions = [];
            for(var i=0;i<userExcursion.questions.length;i++)
            {
              userExcursion.questions[i].isMandatory = parseInt(userExcursion.questions[i].isMandatory);
              userExcursion.userQuestions.push({id:'', userId:userExcursion.userId, excursionQuestionId:userExcursion.questions[i].id, answerId:0, answerText:''});
              for(var j=0;j<userExcursion.questions[i].options.length;j++)
                for(var k=0;k<userExcursion.questions[i].options[j].questions.length;k++)
                  userExcursion.questions[i].options[j].questions[k].isMandatory = parseInt(userExcursion.questions[i].options[j].questions[k].isMandatory);
            }
          },
              error => {
            this.spinner = false;
          }
      );
    }
    else
      this.spinner = false;
  }

  optionSelected(params){
    for(var i=0;i<params.question.options.length;i++)
    {
      if(params.question.options[i].id==params.optionId && (params.userExcursion.userQuestions[params.questionIndex].answerId==params.optionId || params.question.options[i].selected))
      {
        params.question.options[i].userQuestions = [];
        for(var j=0;j<params.question.options[i].questions.length;j++)
          params.question.options[i].userQuestions.push({id:'', userId:params.userExcursion.userId, excursionQuestionId:params.question.options[i].questions[j].id, answerId:0, answerText:''});
      }
    }
    if(params.userExcursion.price)
      this.setPrice(params);
  }

  setPrice(params){
    params.userExcursion.userQuestions[params.questionIndex].price = 0.00;
    for(var i=0;i<params.question.options.length;i++)
    {
      for(var j=0;j<params.question.options[i].userQuestions.length;j++)
        params.question.options[i].userQuestions[j].price = 0.00;
      if(params.userExcursion.userQuestions[params.questionIndex].answerId==params.question.options[i].id || params.question.options[i].selected)
      {
        if(params.question.options[i].isPrice)
        {
          if(params.question.answerType=='Radio')
            params.userExcursion.userQuestions[params.questionIndex].price = parseFloat(params.question.options[i].price);
          else if(params.question.answerType=='Check')
            params.userExcursion.userQuestions[params.questionIndex].price += parseFloat(params.question.options[i].price);
        }
      }
    }
  }

  subOptionSelected(params){
    if(params.userExcursion.price)
      this.setSubPrice(params)
  }

  setSubPrice(params){
    params.option.userQuestions[params.questionIndex].price = 0.00;
    for(var i=0;i<params.question.options.length;i++)
    {
      if(params.option.userQuestions[params.questionIndex].answerId==params.question.options[i].id || params.question.options[i].selected)
      {
        if(params.question.options[i].isPrice)
        {
          if(params.question.answerType=='Radio')
            params.option.userQuestions[params.questionIndex].price = parseFloat(params.question.options[i].price);
          else if(params.question.answerType=='Check')
            params.option.userQuestions[params.questionIndex].price += parseFloat(params.question.options[i].price);
        }
      }
    }
  }

  featureOptionSelected(params){
    this.setFeaturePrice(params);
  }

  setFeaturePrice(params){
    params.userFeature.price = 0.00;
    for(var i=0;i<params.feature.options.length;i++)
    {
      if(params.userFeature.answerId==params.feature.options[i].id || params.feature.options[i].selected)
      {
        if(params.feature.options[i].isPrice)
        {
          if(params.feature.answerType=='Radio')
            params.userFeature.price = parseFloat(params.feature.options[i].price);
          else if(params.feature.answerType=='Check')
            params.userFeature.price += parseFloat(params.feature.options[i].price);
        }
      }
    }
  }

  attendeeFormValid(frm){
    var flag = true;
    if(!frm.valid)
      flag = false;


      if(flag && this.users.password!=this.users.rePassword)
      {
        flag = false;
      }
      if(flag && this.users.email && !this.validateEmail(this.users.email))
      {
        flag = false;
      }
      if(flag && this.users.eventUser.cellPhone && !this.validatePhone(this.users.eventUser.cellPhone))
      {
        flag = false;
      }
      if(flag)
      {
        this.users.eventUser.userExcursions.forEach(function(userExcursion){
          if(userExcursion.checked)
          {
            for(var j=0;j<userExcursion.questions.length;j++)
            {
              if(!flag)
                break;
              if(userExcursion.questions[j].isMandatory==1 && (userExcursion.questions[j].answerType=='TextField' || userExcursion.questions[j].answerType=='Radio') && !(userExcursion.userQuestions[j].answerText || userExcursion.userQuestions[j].answerId>0))
                flag = false;
              for(var k=0;k<userExcursion.questions[j].options.length;k++)
              {
                if(!flag)
                  break;
                if(userExcursion.questions[j].options[k].id!=userExcursion.userQuestions[j].answerId)
                  continue;
                for(var l=0;l<userExcursion.questions[j].options[k].questions.length;l++)
                {
                  if(!flag)
                    break;
                  if(!userExcursion.questions[j].options[k].userQuestions[l])
                    continue;
                  if(userExcursion.questions[j].options[k].questions[l].isMandatory==1 && (userExcursion.questions[j].options[k].questions[l].answerType=='TextField' || userExcursion.questions[j].options[k].questions[l].answerType=='Radio') && !(userExcursion.questions[j].options[k].userQuestions[l].answerText || userExcursion.questions[j].options[k].userQuestions[l].answerId>0))
                    flag = false;
                }
              }
            }
          }
        });
      }

    return flag;
  }

  addAtt(attendeeForm){
    if(attendeeForm.valid && this.attendeeFormValid(attendeeForm)){
      //this.users.eventUser.dob = this.dateTimeFormat(this.users.eventUser.dob_);
      this.disables=true;
      this.spinner = true;
      this.tripService.addAttendee({  users:this.users}).subscribe(
              response => {
            this.spinner = false;
            if(response.status)
            {
              this.snackBar.open('Attendee added Successfully','',{duration:4000});
              this.dialogRef.close(response.status);
            }else{
              this.disables=false;
              this.snackBar.open(response.msg,'',{duration:4000});
            }
          },
              error => {
               this.disables=false;
               this.spinner = false;
          }
      );
    }
  }

  close() {
    this.dialogRef.close();
  }



}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/trip/trip-add-attendee/trip-add-attendee.component.ts